<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }" v-if="showButton">
      <v-btn
        v-on="on"
        outlined
        color="success"
        class="mr-3"
        title="desbloquear"
      >
        <v-icon>mdi-autorenew</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title">Desbloquear Usuário</slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="onCancelModal" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <h2>Deseja realmente desbloquear o usuário?</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            Ao desbloquear um usuário, ele poderá login no sistema.
          </v-col>
        </v-row>
        <v-row v-if="usuario.nome">
          <v-col>Nome : {{ usuario.nome }}</v-col>
        </v-row>
        <v-row>
          <v-col>Email : {{ usuario.email }}</v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" text @click="onCancelModal">Cancelar</v-btn>
        <v-btn color="info" @click="onConfirm">Desbloquear</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { userAPI } from "./UserAPI";
import { mapActions } from "vuex";

export default {
  name: "AppModalConfirmStopSolution",
  props: {
    usuario: { type: Object, required: true },
    open: { type: Boolean, default: false },
    showButton: { type: Boolean, default: true },
  },
  data() {
    return {
      dialog: this.open,
    };
  },
  watch: {
    open(value) {
      if (val) this.dialog = value;
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    onCancelModal() {
      this.dialog = false;
      this.$emit("onCancelModal");
    },
    onConfirm() {
      this.setLoading(true);
      let user = {
        ...this.usuario,
        habilitado: true,
      };
      userAPI
        .habilitarDesabilitarUser(user)
        .then((resp) => {
          this.dialog = false;
          this.$emit("onCloseModal");
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao atualizar usuário");
        });
    },
  },
};
</script>
